document.querySelectorAll('.mega-menu').forEach(function(menuItem) {
    let timeout;

    // When the user hovers over the mega menu container
    menuItem.addEventListener('mouseenter', function() {
        clearTimeout(timeout); // Cancel any pending hide action
        let content = this.querySelector('.mega-menu__content');
        if (content) {
            content.style.display = 'block';  // Show the content
            content.style.opacity = '1';      // Ensure opacity is set to 1
            content.style.transform = 'translateY(0)'; // Move content into view
        }
    });

    // When the user leaves the mega menu container
    menuItem.addEventListener('mouseleave', function() {
        let content = this.querySelector('.mega-menu__content');
        if (content) {
            timeout = setTimeout(function() {
                content.style.display = 'none'; // Hide the content after delay
                content.style.opacity = '0';    // Make it invisible
                content.style.transform = 'translateY(1.5rem)'; // Move content out of view
            }, 300); // Delay before hiding, adjust this time if necessary
        }
    });
});
